import qs from "qs";

export const appendStateToRedirectUrl = (contextUrl, state) => {
  // replace any previous flowState
  const url = new URL(contextUrl);
  const query = qs.parse(url.search, { ignoreQueryPrefix: true });
  const newQs = qs.stringify({
    ...query,
    "tilia-state": state,
  });
  url.search = `?${newQs}`;
  return url.toString();
};

export const getPaypalToken = (location) => {
  const { search } = location;
  const qsParams = new URLSearchParams(search);
  return qsParams.get("token");
};

export const getRedirectState = (location) => {
  const { search } = location;
  const qsParams = new URLSearchParams(search);
  return qsParams.get("state");
};
